export { renderMessageBarBody_unstable as renderMessageBarBody } from '@fluentui/react-message-bar';
